import {useLinePlotSettingsWithDefaults} from '../../WorkspaceDrawer/Settings/runLinePlots/utils/getLinePlotSettings';
import {RunsLinePlotConfig} from '../types';

export const useRunsLinePlotSettings = (config: RunsLinePlotConfig) => {
  return useLinePlotSettingsWithDefaults(config);
};
